/**
 * GiftCardLedgerRowMeta — a ledger row's label, raw enum code, date, booking
 * reference and reason (BON-223).
 */
import { GiftCardBookingRefLink } from './GiftCardBookingRefLink';
import { formatCreatedDate, type GiftCardTxnMeta } from './giftCardsModel';
import type { GiftCardLedgerEntry } from './giftCardTypes';

export function GiftCardLedgerRowMeta({
  entry,
  meta,
}: {
  entry: GiftCardLedgerEntry;
  meta: GiftCardTxnMeta;
}) {
  return (
    <div style={{ flex: 1, minWidth: 0 }}>
      <div
        style={{
          fontSize: 13,
          fontWeight: 700,
          color: 'var(--nb-ink)',
          display: 'flex',
          alignItems: 'center',
          gap: 7,
        }}
      >
        {meta.label}
        <span
          className="nb-mono"
          style={{
            fontSize: 9.5,
            fontWeight: 700,
            letterSpacing: '.04em',
            color: 'var(--nb-faint)',
          }}
        >
          {entry.type}
        </span>
      </div>
      <div
        style={{
          fontSize: 11.5,
          color: 'var(--nb-subtle)',
          display: 'flex',
          alignItems: 'center',
          gap: 6,
          flexWrap: 'wrap',
        }}
      >
        <span>{formatCreatedDate(entry.createdAt)}</span>
        {entry.bookingReference && (
          <>
            <span style={{ opacity: 0.5 }}>·</span>
            <GiftCardBookingRefLink entry={entry} />
          </>
        )}
        {entry.reason && (
          <>
            <span style={{ opacity: 0.5 }}>·</span>
            <span>{entry.reason}</span>
          </>
        )}
      </div>
    </div>
  );
}
